module.exports = __webpack_public_path__ + "img/upload-sub.2331551d.svg";